import apiClient from './apiClient';

export const createEntity = async (entityData) => {
  try {
    const response = await apiClient.post('/entities', entityData, { skipGlobalError: true });
    return {
      success: true,
      data: response.data.data,
      message: response.data.message || 'Entity created successfully',
    };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to create entity';
    return {
      success: false,
      message,
      error: error.response?.data?.error || error.message,
    };
  }
};

export const getEntities = async (filters = {}) => {
  try {
    const queryParams = new URLSearchParams();
    Object.keys(filters).forEach((key) => {
      if (filters[key] !== undefined && filters[key] !== '') {
        queryParams.append(key, filters[key]);
      }
    });

    const response = await apiClient.get(`/entities?${queryParams.toString()}`, { skipGlobalError: true });
    return {
      success: true,
      data: response.data.data,
      message: response.data.message || 'Entities retrieved successfully',
    };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to retrieve entities';
    return {
      success: false,
      message,
      error: error.response?.data?.error || error.message,
    };
  }
};

export const getEntityById = async (id) => {
  try {
    const response = await apiClient.get(`/entities/${id}`, { skipGlobalError: true });
    return {
      success: true,
      data: response.data.data,
      message: response.data.message || 'Entity retrieved successfully',
    };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to retrieve entity';
    return {
      success: false,
      message,
      error: error.response?.data?.error || error.message,
    };
  }
};

export const updateEntity = async (id, entityData) => {
  try {
    const response = await apiClient.put(`/entities/${id}`, entityData, { skipGlobalError: true });
    return {
      success: true,
      data: response.data.data,
      message: response.data.message || 'Entity updated successfully',
    };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to update entity';
    return {
      success: false,
      message,
      error: error.response?.data?.error || error.message,
    };
  }
};

export const deleteEntity = async (id) => {
  try {
    const response = await apiClient.delete(`/entities/${id}`, { skipGlobalError: true });
    return {
      success: true,
      data: response.data.data,
      message: response.data.message || 'Entity deleted successfully',
    };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to delete entity';
    return {
      success: false,
      message,
      error: error.response?.data?.error || error.message,
    };
  }
};
